import ComplianceIcon from './compliance.svg';
import EncryptionIcon from './encryption.svg';
import KeyIcon from './key.svg';
import SSLCertificatesIcon from './sslCertificates.svg';

export { ComplianceIcon, EncryptionIcon, KeyIcon, SSLCertificatesIcon };
